import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ProjectFilters = ({ 
  searchQuery, 
  onSearchChange, 
  selectedType, 
  onTypeChange, 
  selectedTech, 
  onTechChange, 
  sortBy, 
  onSortChange,
  onClearFilters,
  resultCount 
}) => {
  const projectTypes = [
    { value: 'all', label: 'All Projects' },
    { value: 'Web App', label: 'Web Applications' },
    { value: 'Mobile App', label: 'Mobile Apps' },
    { value: 'API', label: 'APIs & Backend' },
    { value: 'Library', label: 'Libraries' }
  ];

  const technologies = [
    'React', 'Node.js', 'TypeScript', 'Next.js', 'MongoDB', 
    'Express', 'Tailwind', 'Firebase', 'PostgreSQL', 'Python',
    'Django', 'Vue.js', 'AWS', 'Docker', 'GraphQL'
  ];

  const sortOptions = [
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'rating', label: 'Highest Rated' },
    { value: 'name', label: 'Alphabetical' }
  ];

  const hasActiveFilters = selectedType !== 'all' || selectedTech?.length > 0 || searchQuery;

  return (
    <div className="bg-card rounded-xl shadow-subtle p-6 mb-8">
      {/* Search Bar */}
      <div className="mb-6">
        <div className="relative">
          <Input
            type="search"
            placeholder="Search projects by name, description, or technology..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="pl-10"
          />
          <Icon 
            name="Search" 
            size={20} 
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
          />
        </div>
      </div>
      {/* Filter Controls */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {/* Project Type Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Project Type
          </label>
          <select
            value={selectedType}
            onChange={(e) => onTypeChange(e?.target?.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
          >
            {projectTypes?.map(type => (
              <option key={type?.value} value={type?.value}>
                {type?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Sort Options */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Sort By
          </label>
          <select
            value={sortBy}
            onChange={(e) => onSortChange(e?.target?.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
          >
            {sortOptions?.map(option => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Clear Filters */}
        <div className="flex items-end">
          <Button
            variant="outline"
            onClick={onClearFilters}
            disabled={!hasActiveFilters}
            iconName="X"
            iconPosition="left"
            fullWidth
          >
            Clear Filters
          </Button>
        </div>
      </div>
      {/* Technology Filter Chips */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-foreground mb-3">
          Filter by Technology
        </label>
        <div className="flex flex-wrap gap-2">
          {technologies?.map(tech => (
            <button
              key={tech}
              onClick={() => {
                if (selectedTech?.includes(tech)) {
                  onTechChange(selectedTech?.filter(t => t !== tech));
                } else {
                  onTechChange([...selectedTech, tech]);
                }
              }}
              className={`px-3 py-1 text-sm font-medium rounded-full border transition-all duration-200 ${
                selectedTech?.includes(tech)
                  ? 'bg-primary text-primary-foreground border-primary'
                  : 'bg-background text-muted-foreground border-border hover:border-primary hover:text-primary'
              }`}
            >
              {tech}
              {selectedTech?.includes(tech) && (
                <Icon name="X" size={14} className="ml-1 inline" />
              )}
            </button>
          ))}
        </div>
      </div>
      {/* Results Count */}
      <div className="flex items-center justify-between text-sm text-muted-foreground">
        <span>
          {resultCount} project{resultCount !== 1 ? 's' : ''} found
        </span>
        {hasActiveFilters && (
          <div className="flex items-center space-x-2">
            <Icon name="Filter" size={16} />
            <span>Filters active</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectFilters;